/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-11-26 11:56:04
 */

import React, { useEffect, useState } from 'react'
import { Modal, Radio } from 'antd'
import sensors from '../../../utils/sensors'

export enum EmbedType {
  IMAGE_EMBED = 1,
  IMAGE_FLOAT = 0,
  NO_IMAGE = 2
}

interface PhotoEmbedTypeDialogProps {
  visible: boolean
  totalCount: number
  onCancel: () => void
  onOk: (embedType: EmbedType) => void
}

const radioStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: 8,
  color: '#1F2329'
}

const PhotoEmbedTypeDialog: React.FC<PhotoEmbedTypeDialogProps> = ({
  visible,
  totalCount,
  onCancel,
  onOk
}) => {
  const [embedType, setEmbedType] = useState(EmbedType.IMAGE_EMBED)
  const handleOk = () => {
    onOk(embedType)
    handleSensorTrack(
      'export',
      embedType === EmbedType.IMAGE_EMBED
        ? 'photoEmbedded'
        : embedType === EmbedType.IMAGE_FLOAT
          ? 'photoFloating'
          : 'noPhoto'
    )
  }

  const handleCancel = () => {
    handleSensorTrack('cancel')
    onCancel()
  }

  const handleSensorTrack = (actionType: string, exportType = '') => {
    sensors.track('other_b4366_c7742_click', {
      actionType,
      exportType,
      photosNum: totalCount,
      track_sign: 'aother.b4366.c7742.click.other_b4366_c7742_click',
      requirement_id: 521
    })
  }

  useEffect(() => {
    if (visible) {
      setEmbedType(EmbedType.IMAGE_EMBED)
      handleSensorTrack('enterPage')
    }
  }, [visible])

  return (
    <Modal
      open={visible}
      centered
      onCancel={handleCancel}
      onOk={handleOk}
      okText="导出"
      cancelText="取消"
    >
      <h3>导出为Excel（.xlsx）</h3>
      <p>可选择不同导出方式，支持不同的查看操作</p>
      <Radio.Group
        value={embedType}
        onChange={(e) => setEmbedType(e.target.value)}
      >
        <Radio style={radioStyle} value={EmbedType.IMAGE_EMBED}>
          图片内嵌在表格中（支持筛选排序）
        </Radio>
        <Radio style={radioStyle} value={EmbedType.IMAGE_FLOAT}>
          图片浮动在表格中（支持放大查看）
        </Radio>
        <Radio style={radioStyle} value={EmbedType.NO_IMAGE}>
          表格不包含图片
        </Radio>
      </Radio.Group>
      <p
        style={{
          color: '#86909c',
          fontSize: 14,
          marginTop: 16,
          marginBottom: 0
        }}
      >
        *您可通过列显示设置修改导出 Excel 文件包含的字段。
      </p>
    </Modal>
  )
}

export default PhotoEmbedTypeDialog
